import { useCallback } from 'react'
import { AgxSpacer, AgxTextInput } from '@urbanx/agx.ui-components2'
import { Deposit, ValueType } from '@urbanx/agx.campaigns.client'
import { parseNumber } from 'utils/parseNumber'
import { DepositType } from '@urbanx/agx-ui-components'

export const QldDepositOptions = [
  { label: ValueType.Dollar, value: ValueType.Dollar },
  { label: ValueType.Percentage, value: ValueType.Percentage },
]

interface QldDepositOptionsProps {
  id: string
  depositType: DepositType
  onDepositChange: (updater: (prev: Deposit | undefined) => Deposit) => void
}

export function QldDepositOptionsComponent({
  id,
  depositType,
  onDepositChange,
}: QldDepositOptionsProps) {
  const handleAmountChange = useCallback(
    (value: string | undefined) => {
      onDepositChange((prev) => ({
        ...prev,
        amount: value ? parseNumber(value) : undefined,
        percent: undefined,
        depositValueType: ValueType.Dollar,
      }))
    },
    [onDepositChange]
  )

  return (
    <AgxSpacer direction="horizontal" fill>
      <AgxTextInput
        id={`${id}-amount`}
        label={`${depositType === DepositType.Balance ? 'Balance' : 'Initial'} Deposit`}
        required
        type="currency"
        stretch
        hideOptionalText
        onChange={handleAmountChange}
      />
    </AgxSpacer>
  )
}
